export default __webpack_public_path__ + "static/media/horizon.38f24ba4.svg";